import { render, staticRenderFns } from "./DisplayPropertiesSidebar.vue?vue&type=template&id=536cd9a3&scoped=true&"
import script from "./DisplayPropertiesSidebar.vue?vue&type=script&lang=js&"
export * from "./DisplayPropertiesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPropertiesSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DisplayPropertiesSidebar.vue?vue&type=style&index=1&id=536cd9a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536cd9a3",
  null
  
)

export default component.exports